<template>
  <div class="wrapper">
    <HeaderNav title="市场人员比例" v-if="!isMobile"></HeaderNav>
    <div class="container">
      <div class="section">
        <div class="row">
          <div class="row-name">市场负责人</div>
          <div class="row-cont">
            <el-select v-model="memberScaleForm.leader" filterable placeholder="请选择" class="row-cont-select">
              <el-option
                v-for="(item, index) in marketLeaderList"
                :key="index"
                :label="item.realName"
                :value="item.userId">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="section">
        <h3>市场人员提成：</h3>
        <div class="row">
          <div class="row-name">年费比例（总和为100%）</div>
          <div class="row-cont" v-for="(item, index) in memberScaleForm.annualFeeList">
            <div class="row-cont-lf">
              <el-select v-model="item.user" filterable class="row-cont-lf-select">
                <el-option
                  v-for="(item, index) in marketLeaderList"
                  :key="index"
                  :label="item.realName"
                  :value="item.userId">
                </el-option>
              </el-select>
              <input type="text" v-model="item.scale" :disabled="item.isDisable" @input="item.scale=toRegNum(item.scale)" class="row-cont-lf-input" />
              <div class="row-cont-lf-btn">%</div>
            </div>
            <div class="iconfont icon-delete" v-show="memberScaleForm.annualFeeList.length > 1" @click="toDeleteAnnualFee(index)"></div>
          </div>
          <div class="row-add-box" @click="toAddAnnualFee" v-show="memberScaleForm.annualFeeList.length < 3">
            <span class="iconfont icon-add2"></span>添加人员...
          </div>
        </div>
      </div>
      <div class="section">
        <div class="row">
          <div class="row-name">技术服务费比例（总和为100%）</div>
          <div class="row-cont" v-for="(item, index) in memberScaleForm.serviceFeeList" :key="item.id">
            <div class="row-cont-lf">
              <el-select v-model="item.user" filterable class="row-cont-lf-select">
                <el-option
                  v-for="(item, index) in marketLeaderList"
                  :key="index"
                  :label="item.realName"
                  :value="item.userId">
                </el-option>
              </el-select>
              <input type="text"  v-model="item.scale" :disabled="item.isDisable" @input="item.scale=toRegNum(item.scale)" class="row-cont-lf-input" />
              <div class="row-cont-lf-btn">%</div>
            </div>
            <div class="iconfont icon-delete" v-show="memberScaleForm.serviceFeeList.length > 1" @click="toDeleteServiceFee(index)"></div>
          </div>
          <div class="row-add-box" @click="toAddServiceFee" v-show="memberScaleForm.serviceFeeList.length < 3">
            <span class="iconfont icon-add2"></span>添加人员...
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bar"></div>
    <div class="footer">
      <div class="footer-btn default-btn" @click="toPrev">上一步</div>
      <div class="footer-btn confirm-btn" @click="onSubmit">完成设置</div>
    </div>
    <ContactBtn />
  </div>
</template>


<script>
import { AppUtils } from '@/utils/bridge';
import { getMealInfo, getAnnualFeeInfo, getMarketList,addMarket,getMarketInfo  }  from '@/api/baseinfo';
export default {
  name: 'apply-package',
  data () {
    return {
      isMobile: false,
      shopCode: undefined,
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      labelNo:1,
      labelList:[{name:'送1个月',value:1},{name:'送2个月',value:2},{name:'送3个月',value:3}],
      marketRatioList:[],
      serviceFeeList:[],
      form: {},

      marketLeaderList:[],
      memberScaleForm: {
        leader: null,
        annualFeeList: [{
          user: '',
          scale: '100'
        }],
        serviceFeeList: [{
          user: '',
          scale: '100'
        }],
      },
      isRepeat: false,
      userId: null,
    }
  },
  created() {
    this.shopCode = this.$route.query ? this.$route.query.shopCode : undefined;
    this.mobileTerminal((data) => {
      this.isMobile = data
    })
    if(AppUtils.isInNative()){
      AppUtils.getUserInfo(data => {
        this.userId = String(data.userId);
        // console.log('data===', AppUtils.isInNative(), data)
        this.getMarketList();
        this.getMarketInfo();
      })
    }else{
      this.getMarketList();
      this.getMarketInfo();
    }
  },
  methods: {
    getMarketList() {
      getMarketList().then(res => {
        if(res.data&&res.data.length>0&&res.data.findIndex(v=>{return v.userId==this.userId})==-1){
          this.userId = null;
        }
        this.marketLeaderList = res.data;
      });
    },
    getMarketInfo() {
      getMarketInfo(this.shopCode).then(res => {
        // console.log('getMarketInfo--res====',res)
        let data = res.data;
        this.memberScaleForm.leader = data&&data.leadingId ? String(data.leadingId) : null;
        if(data.peopleInfoDtoList&&data.peopleInfoDtoList.length>0) {
          this.memberScaleForm.annualFeeList = [];
          this.memberScaleForm.serviceFeeList = [];
          data.peopleInfoDtoList.forEach(item => {
            if(item.feeType == 1) {
              this.memberScaleForm.annualFeeList.push({
                user: item.userId&&item.userId!=''?String(item.userId):this.userId,
                scale: item.feeInfo
              })
            } else if(item.feeType == 2) {
              this.memberScaleForm.serviceFeeList.push({
                user: item.userId&&item.userId!=''?String(item.userId):this.userId,
                scale: item.feeInfo
              })
            }
          })
          // console.log('memberScaleForm1111===', data.peopleInfoDtoList)
        }else{
          this.memberScaleForm.leader = this.userId;
          this.memberScaleForm.annualFeeList = [{
            user: this.userId,
            scale: '100'
          }],
          this.memberScaleForm.serviceFeeList = [{
            user: this.userId,
            scale: '100'
          }]
          // console.log('memberScaleForm2222===', this.memberScaleForm)
        }
      })
    },
    cTag(item){
      this.labelNo = item.value;
    },
    toAddMarket(){
      if(this.marketRatioList.length>=3) return this.Toast('最多添加3个');
      this.marketRatioList.push({

      })
    },
    toAddAnnualFee() {
      if(this.memberScaleForm.annualFeeList.length >= 3) return false;
      this.memberScaleForm.annualFeeList.push({
        user: '',
        scale: '',
        isDisable: false
      })
      if(this.memberScaleForm.annualFeeList.length === 2) {
        this.memberScaleForm.annualFeeList.forEach(item => {
          item.scale = 50;
          item.isDisable = false;
        })
      }
      if(this.memberScaleForm.annualFeeList.length === 3) {
        this.memberScaleForm.annualFeeList.forEach((item, index) => {
          if(index === 0) {
            item.scale = 34;
          } else{
            item.scale = 33;
          }
          item.isDisable = false;
        })
      }
    },
    toAddServiceFee() {
      if(this.memberScaleForm.serviceFeeList.length >= 3) return false;
      this.memberScaleForm.serviceFeeList.push({
        user: '',
        scale: '',
        isDisable: false
      })
      if(this.memberScaleForm.serviceFeeList.length === 2) {
        this.memberScaleForm.serviceFeeList.forEach(item => {
          item.scale = 50;
          item.isDisable = false;
        })
      }
      if(this.memberScaleForm.serviceFeeList.length === 3) {
        this.memberScaleForm.serviceFeeList.forEach((item, index) => {
          if(index === 0) {
            item.scale = 34;
          } else{
            item.scale = 33;
          }
          item.isDisable = false;
        })
      }
    },
    toDeleteAnnualFee(index) {
      if(this.memberScaleForm.annualFeeList.length <= 1) return false;
      this.memberScaleForm.annualFeeList.splice(index, 1);
      if(this.memberScaleForm.annualFeeList.length === 2) {
        this.memberScaleForm.annualFeeList.forEach(item => {
          item.scale = 50;
          item.isDisable = false;
        })
      }
      if(this.memberScaleForm.annualFeeList.length === 1) {
        this.memberScaleForm.annualFeeList.forEach(item => {
          item.scale = 100;
          item.isDisable = true;
        })
      }
    },
    toDeleteServiceFee(index) {
      if(this.memberScaleForm.serviceFeeList.length <= 1) return false;
      this.memberScaleForm.serviceFeeList.splice(index, 1);
      if(this.memberScaleForm.serviceFeeList.length === 2) {
        this.memberScaleForm.serviceFeeList.forEach(item => {
          item.scale = 50;
          item.isDisable = false;
        })
      }
      if(this.memberScaleForm.serviceFeeList.length === 1) {
        this.memberScaleForm.serviceFeeList.forEach(item => {
          item.scale = 100;
          item.isDisable = true;
        })
      }
    },
    toDelete(index){
      this.serviceFeeList.splice(index,1);
    },
    toPrev() {
      this.$router.go(-1);
    },
    onSubmit() {
      let peopleInfoArr = [];
      let annualFeeTotal = 0;
      let serviceFeeTotal = 0;
      if(!this.memberScaleForm.leader) return this.Toast('请选择市场负责人~');
      if(this.memberScaleForm.annualFeeList.length>0&&this.memberScaleForm.annualFeeList.findIndex(v=>{return !v.user||v.user==''})!=-1) return this.Toast('请选择市场人员~');
      if(this.memberScaleForm.serviceFeeList.length>0&&this.memberScaleForm.serviceFeeList.findIndex(v=>{return !v.user||v.user==''})!=-1) return this.Toast('请选择市场人员~');
      if(this.memberScaleForm.annualFeeList.length>0&&this.memberScaleForm.annualFeeList.findIndex(v=>{return !v.scale||v.scale==''})!=-1) return this.Toast('请设置年费比例~');
      if(this.memberScaleForm.serviceFeeList.length>0&&this.memberScaleForm.serviceFeeList.findIndex(v=>{return !v.scale||v.scale==''})!=-1) return this.Toast('请设置技术服务费比例~');
      this.memberScaleForm.annualFeeList.forEach(item => {
        annualFeeTotal += Number(item.scale);
        peopleInfoArr.push({
          "feeInfo": item.scale,
          "feeType": 1,
          "userId": item.user
        })
      })
      if(annualFeeTotal!=100) return this.Toast('年费比例总和为100%~');
      this.memberScaleForm.serviceFeeList.forEach(item => {
        serviceFeeTotal += Number(item.scale);
        peopleInfoArr.push({
          "feeInfo": item.scale,
          "feeType": 2,
          "userId": item.user
        })
      })
      if(serviceFeeTotal!=100) return this.Toast('技术服务费比例总和为100%~');
      let params = {
        "leadingId": this.memberScaleForm.leader,
        "peopleInfoDtoList": peopleInfoArr,
        "shopMallCode": this.shopCode
      }
      if(this.isRepeat) return false;
      this.isRepeat = true;
      addMarket(params).then(res => {
        this.isRepeat = false;
        this.Toast('设置成功~')
        this.$router.push({
          path: '/agreement?shopCode=' + this.shopCode
        })

        // if(isSetting===1) {
        //   this.Toast('设置成功~')
        //   this.settingDialogVisible = false;
        //   this.getList();
        // } else if(isSetting===2) {
        //   if(!this.settingFlow.includes(4)) {
        //     this.settingFlow.push(4);
        //   }
        //   if(this.businessScaleForm.setMealMoney>0){
        //     this.getUpgradeAnnualFee();
        //   }else{
        //     this.settingDialogVisible = false;
        //     this.getList();
        //   }     
        // }  else {
        //   this.Toast('设置成功~')
        //   this.memberScaleDialogVisible = false;
        //   this.getList();
        // }
      }).catch(err=>{
        this.isRepeat = false;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container{
  padding-top: 20px;
}
.set-default{
  font-size: 14px;
  color: #67B4C4;
  text-align: right;
  margin: 0 20px 20px;
}
.section{
  margin-bottom: 40px;
  h3{
    font-size: 16px;
    color: #222;
    margin: 0 20px 12px;
  }
}
.row{
  margin: 0 20px 20px;
  &:last-child{
    margin-bottom: 0;
  }
  &-name{
    line-height: 20px;
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
  }
  &-add-box{
    font-size: 14px;
    color: #47B6C7;
    display: flex;
    align-items: center;
    margin-top: 12px;
    cursor: pointer;
    .icon-add2{
      font-size: 20px;
      margin-right: 4px;
    }
  }
  &-cont{
    width: 100%;
    display: flex;
    margin-bottom: 10px;
    &-select{
      width: 100%;
      border: 1px solid #D8E0F0;
      border-radius: 10px;
    }
    &-lf{
      display: flex;
      align-items: center;
      border: 1px solid #D8E0F0;
      border-radius: 10px;
      &-select{
        //width: 140px;
        height: 48px;
      }
      &-btn{
        width: 48px;
        height: 48px;
        background: #FFFFFF;
        font-size: 14px;
        color: #7D8592;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0 10px 10px 0;
      }
      &-input{
        width: 104px;
        height: 48px;
        font-size: 14px;
        color: #222;
        font-weight: 500;
        text-align: center;
        border-left: 1px solid #D8E0F0;
        border-right: 1px solid #D8E0F0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
        box-sizing: border-box;
        border-radius: 0 !important;
      }
    }
    .icon-delete{
      width: 20px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      color: #567B9C;
      margin-left: 12px;
      cursor: pointer;
    }
  }
  .tag-group{
    margin-top: 10px;
    .tag-item-active{
      background: #ECF7F9;
      color: #67B4C4;
      border: 0;
    }
  }
}


.footer{
  display: flex;
  align-items: center;
  justify-content: center;
  &-btn{
    width: 130px;
    height: 44px;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 12px;
  }
  .default-btn{
    background: #FFFFFF;
    border: 1px solid #EEEEEE;  
    color: #222;
  }
  .confirm-btn{
    background: #67B4C4;
    color: #fff;
  }
}
/deep/ .el-input__inner{
  height: 48px;
  border: 0;
  border-radius: 10px;
}
@media screen and (max-width:750px){

}
@media screen and (min-width:750px){
  
}
</style>



// WEBPACK FOOTER //
// src/views/marketRatio.vue